<template>
  <b-modal
    v-model="showModal"
    @hide="onHide"
    hide-footer
    hide-header
    centered
    body-class="pd-0"
  >
    <div v-if="rdy && task.user!=null" class="card card-profile">
      <img src="assets/img/appbg.jpg" class="card-img-top" alt="" />
      <div class="card-body tx-13">
        <div>
          <a>
            <div class="avatar avatar-xxl">
              <img
                :src="task.defaultAttachmentUrl"
                class="rounded-circle"
                alt=""
              />
            </div>
          </a>
          <h5>
            <a>{{ task.user.fullName.split("?w=")[0] }}</a>
          </h5>
          <p>{{ task.user.position }}</p>
        </div>
        <!-- {{$store.state.user.userInfo.groupId}} -->
        <table class="wd-100p">
          <tbody>
            <template v-if="$store.state.user.userInfo.groupId == 9265">
              <!-- BFA -->
              <!-- <tr>
              <td class="text-right pd-r-10">Байгууллага</td>
              <td class="font-weight-bold">{{ task.groupName }}</td>
            </tr> -->
              <!-- <tr>
                <td class="text-right pd-r-10">Байгууллага</td>
                <td class="font-weight-bold">{{ task.departName }}</td>
              </tr> -->
              <tr>
                <td class="text-right pd-r-10">Байгууллага</td>
                <td class="font-weight-bold">
                  {{ task.departName }} {{ task.s6 }}
                </td>
              </tr>
              <tr>
                <td class="text-right pd-r-10">Нэгж</td>
                <td class="font-weight-bold">{{ task.s7 }}</td>
              </tr>
              <tr>
                <td class="text-right pd-r-10">Албан тушаал</td>
                <td class="font-weight-bold">{{ task.position }}</td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td class="text-right pd-r-10">Байгууллага</td>
                <td class="font-weight-bold">{{ task.groupName }}</td>
              </tr>
              <tr>
                <td class="text-right pd-r-10">Нэгжийн нэр</td>
                <td class="font-weight-bold">{{ task.departName }}</td>
              </tr>
              <tr>
                <td class="text-right pd-r-10">Албан тушаал</td>
                <td class="font-weight-bold">{{ task.position }}</td>
              </tr>
            </template>
            <tr>
              <td colspan="2">
                <div class="bd-b mg-y-20"></div>
              </td>
            </tr>
            <tr>
              <td class="text-right pd-r-10 wd-40p">Нэвтрэх нэр</td>
              <td class="font-weight-bold">{{ task.user.loginName }}</td>
            </tr>
            <tr>
              <td class="text-right pd-r-10">Овог</td>
              <td class="font-weight-bold">{{ task.user.lastName }}</td>
            </tr>
            <tr>
              <td class="text-right pd-r-10">Нэр</td>
              <td class="font-weight-bold">{{ task.user.firstName }}</td>
            </tr>
            <tr>
              <td class="text-right pd-r-10">Утас</td>
              <td class="font-weight-bold">{{ task.user.mobile }}</td>
            </tr>
            <tr>
              <td class="text-right pd-r-10">И-мэйл</td>
              <td class="font-weight-bold">{{ task.user.email }}</td>
            </tr>
            <tr v-if="$store.state.user.userInfo.groupId == 9247">
              <td class="text-right pd-r-10">Оршин суугаа хаяг</td>
              <td class="font-weight-bold">{{ task.s1 }}</td>
            </tr>
          </tbody>
        </table>

        <section class="pos-absolute t-10 r-10">
          <button @click="$emit('on-hide'); 
                  handleMainReportDialog({
                    key: 'learn_userReport',
                    show: true,
                    propObj: { loginName: task.user.loginName },
                  })
                " role="button" class="btn btn-primary btn-xs btn-uppercase">Хамрагдсан сургалтууд</button>
        </section>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { request } from "@/api/all";
import { mapActions } from "vuex";

export default {
  props: {
    isShow: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      rdy: false,
      task: {
        defaultAttachmentUrl: null,
        user: null
      },
    };
  },
  methods: {
    ...mapActions(["handleLoading", "handleMainReportDialog"]),
    onHide(){
      
      // this.task.user= null;
      // this.task.defaultAttachmentUrl= null;
      // this.rdy=false;
      Object.assign(this.$data, this.$options.data());

      this.$emit('on-hide');
    },
    init() {
      //console.log('stp 1', this.$store.state.app.userInfoId);
      request({
        api: { method: "get", url: "task/info" },
        params: { id: this.$store.state.app.userInfoId },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.task = res.data.task;
          this.rdy = true;
          //console.log('rs=> ', res);
        }
      });
    },
  },
  computed: {
    showModal: {
      get: function () {
        if (this.isShow) this.init();
        return this.isShow;
      },
      set: function () {},
    },
  },
};
</script>

<style></style>
